import { getUserCoursesList, getCourses } from "../../services/courses.service"
import { createAsyncThunk } from '@reduxjs/toolkit';

export const processFetchingDashboardDetails = createAsyncThunk(
  'courses/fetchDashboardDetails',
  async (_, { rejectWithValue }) => {
    try {
      const [coursesData, userCoursesData] = await Promise.all([
        getCourses(),
        getUserCoursesList()
      ]);     

      return {
        courses: coursesData.data?.data || coursesData.data?.result || coursesData.data || [], // ✅ handles all cases
        usersCoursesDetails: userCoursesData.data?.data || userCoursesData.data?.result || userCoursesData.data || []
      };
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue({
        courses: [],
        usersCoursesDetails: []
      });
    }
  }
);